/* import __COLOCATED_TEMPLATE__ from './visibility-section.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
  Args: {
    selectedPreset: string;
    onSelectPreset: (preset: string) => void;
  };
}

const SalesVisibilitySection = templateOnlyComponent<Signature>();
export default SalesVisibilitySection;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Sales::VisibilitySection': typeof SalesVisibilitySection;
  }
}
